<!-- eslint-disable vue/no-v-html -->
<template>
    <div
        data-allow-mismatch
        v-html="content"
    />
</template>
<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{ content: string }>()

const content = computed(() => {
    let result = props.content

    /**
     * The props.content can be an invalid html string.
     * If that happens, the result SSR can be invalid as well, leading to broken layout on the client.
     * However, if this component is mounted without hydration, it will be fine, as on the client vue passes v-html content though DOMParser which autofixes all issues.
     * So the only problem is to do the same "fix" on the server side.
     * For that I'm using cheerio parsing/serialization.
     */
    if (typeof window === 'undefined') {
        /**
         * require() happens only on server
         * "cheerio" is added to webpack "externals" to prevent bundling
         */
        const loadOptions = null
        const isDocument = false // we are parsing "fragment"
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        result = require('cheerio').load(result, loadOptions, isDocument).html()
    }

    // Process the content: remove HTML comments and add lazy loading
    return (
        result
            // Remove HTML comments
            .replace(/<!--[\s\S]*?-->/g, '')
            // Add loading="lazy" to img tag
            .replace(/(<img\s)([^>]*?)(\/?>)/gi, (match, start, attributes, end) => {
                if (attributes.includes('loading=')) {
                    return match
                }
                return `${start}loading="lazy" ${attributes}${end}`
            })
            // Add loading="lazy" to iframe tag
            .replace(/(<iframe\s)([^>]*?)(>)/gi, (match, start, attributes, end) => {
                if (attributes.includes('loading=')) {
                    return match
                }
                return `${start}loading="lazy" ${attributes}${end}`
            })
    )
})
</script>
